import React, { useEffect, useState, useCallback } from "react";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import { SvgImages } from "../../Utils/LocalImages";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import { InputType, handleApiErrors, validationRegex } from "../../Utils/Utils";
import CustomTextField from "../../Components/Reusable/CustomTextField";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import RoutesPath from "../../Utils/RoutesPath";
import DataProvider from "../../Utils/DataProvider";
import CoordinatorService from "../../Services/CoordinatorService";
import StateService from "../../Services/StateService";


const AddCoordinators = () => {
  const [coordinator, setCoordinator] = useState({ ...useLocation().state });
  const [termsChecked, setTermsChecked] = useState(coordinator.notifyEmail || false);
  const [states, setStates] = useState([]);
  const [resetDistrict, setResetDistrict] = useState(false);
  const [resetTaluka, setResetTaluka] = useState(false);
  const [resetPinCode, setResetPinCode] = useState(false);

  const navigate = useNavigate();
  const Validations = yup.object().shape({
    name: validationRegex.required,
    email: validationRegex.email,
    dateOfBirth: validationRegex.dob,
    mobile: validationRegex.mobile,
    terms: validationRegex.terms,
    qualification: validationRegex.required,
    addressLineOne: validationRegex.required,
    addressLineTwo: validationRegex.required,
    state: validationRegex.required,
    district: validationRegex.required,
    taluka: validationRegex.required,
    pinCode: validationRegex.required,
  });
  const {
    register: register,
    handleSubmit: handleSubmit,
    setValue: setValues,
    watch: watchdetails,
    formState: { errors: errors, },
    getValues: getValues,
  } = useForm({
    resolver: yupResolver(Validations),
    defaultValues: {
      name: coordinator?.coordinatorName || "",
      email: coordinator?.email || "",
      mobile: coordinator?.mobile || "",
      dateOfBirth: coordinator?.dateOfBirth|| "",
      qualification: coordinator?.qualification || "",
      addressLineOne: coordinator?.addressLineOne || "",
      addressLineTwo: coordinator?.addressLineTwo || "",
      state: coordinator?.stateId || "",
      district: coordinator?.district || "",
      taluka: coordinator?.taluka || "",
      pinCode: coordinator?.pinCode || "",
      referralCode: coordinator?.referralCode || "",
    },
  });

  const onSubmit = async (coordinatorData) => {
    try {
      // Call BlogService to add the blog
      const response = await CoordinatorService.addCoordinator(
        coordinatorData.name,
        coordinatorData.email,
        coordinatorData.mobile,
        coordinatorData.dateOfBirth,
        coordinatorData.qualification,
        coordinatorData.addressLineOne,
        coordinatorData.addressLineTwo,
        coordinatorData.state,
        coordinatorData.district,
        coordinatorData.taluka,
        coordinatorData.pinCode,
        termsChecked === true ? "true" : "false"
      );
      toast.success(response.message);
      navigate(RoutesPath.viewCoordinator);
      setCoordinator({})
    } catch (error) {
      // Handle API errors
      handleApiErrors(error);
      toast.error("Failed to add coordinator. Please try again later.");
    }
  };
  const editCoordinator = async (coordinatorData) => {
    console.log(coordinatorData,"rgjhrjk")
    try {
      // Call BlogService to add the blog
      const response = await CoordinatorService.editCoordinator(
        coordinator.coordinator_id || "",
        coordinatorData.name,
        coordinatorData.email,
        coordinatorData.mobile,
        coordinatorData.dateOfBirth,
        coordinatorData.qualification,
        coordinatorData.addressLineOne,
        coordinatorData.addressLineTwo,
        coordinatorData.state,
        coordinatorData.district,
        coordinatorData.taluka,
        coordinatorData.pinCode,
        termsChecked === true ? "true" : "false"
      );
      toast.success(response.message);
      navigate(RoutesPath.viewCoordinator);
      setCoordinator({})
    } catch (error) {
      // Handle API errors
      handleApiErrors(error);
      toast.error("Failed to add coordinator. Please try again later.");
    }
  };

  const getAllStates = async () => {
    try {
      const response = await StateService.getAll();
      setStates(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => {
    getAllStates();
  }, [])


  return (
    <div>
      <div className="mb-3 d-flex justify-content-between">
        <h1 className="black fs-18 fw-600 mb-0">{coordinator.coordinator_id ? "Edit COORDINATORS" : "COORDINATORS"}</h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0"> {coordinator.coordinator_id ? "Edit Coordinators" : "Coordinators"}</h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <div className="table_title ps-2">
          <div className="table_headings">
            <h1 className="black fs-18 fw-600 mb-0">
              {coordinator.coordinator_id ? "Edit Coordinators" : "Add Coordinators"}
            </h1>
          </div>

          <form className="" onSubmit={handleSubmit(onSubmit)}>
            <div className="row profile_inputs w-100 mt-4">
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Coordinators Name"
                  placeholder="Coordinators Name"
                  name="name"
                  id="name"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.name}
                  errorMessage={errors?.name?.message}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Coordinators Email ID"
                  additionalClasses="profile_edit"
                  id="email"
                  name="email"
                  showMandatory={true}
                  placeholder="Enter your email"
                  showError={errors?.email}
                  errorMessage={errors?.email?.message}
                  register={register}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Coordinators Mobile Number"
                  placeholder="Coordinators Mobile Number"
                  id="mobile"
                  name="mobile"
                  inputType={InputType.number}
                  showError={errors?.mobile}
                  errorMessage={errors?.mobile?.message}
                  register={register}
                  additionalClasses="profile_edit"
                  showMandatory={true}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Date of Birth"
                  id="dateOfBirth"
                  name="dateOfBirth"
                  showError={errors?.dateOfBirth}
                  errorMessage={errors?.dateOfBirth?.message}
                  register={register}
                  additionalClasses="profile_edit"
                  inputType="date"
                  setValue={setValues}
                  showMandatory={true}
                />
              </div>
              <div className="col-md-6">
                {/* {classes && classes.length != 0 && ( */}
                <CustomDropDown
                  labelTitle="Qualification"
                  placeholder="Select"
                  name="qualification"
                  id="qualification"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showError={errors?.qualification}
                  errorMessage={errors?.qualification?.message}
                  showMandatory={true}
                  setValue={setValues}
                  options={
                    DataProvider.standaredList
                  }
                  defaultOption={() => {
                    return coordinator.qualification ? { value: coordinator.qualification, label: coordinator.qualification } : null
                  }}
                />
                {/* )} */}
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Address Line 1"
                  placeholder="Address Line 1"
                  id="addressLineOne"
                  name="addressLineOne"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.addressLineOne}
                  errorMessage={errors?.addressLineOne?.message}
                />
              </div>
              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Address Line 2"
                  placeholder="Address Line 2"
                  id="addressLineTwo"
                  name="addressLineTwo"
                  additionalClasses="profile_edit"
                  inputType={InputType.text}
                  showMandatory={true}
                  register={register}
                  showError={errors?.addressLineTwo}
                  errorMessage={errors?.addressLineTwo?.message}
                />
              </div>
              <div className="col-md-6">
                <CustomDropDown
                  labelTitle="State"
                  id="state"
                  name="state"
                  placeholder="Select State"
                  showError={errors?.state}
                  errorMessage={errors?.state?.message}
                  register={register}
                  additionalClasses="profile_edit"
                  setValue={setValues}
                  showMandatory={true}
                  options={states.map((e) => {
                    return { value: e._id, label: e.name };
                  })}
                  defaultOption={() => {
                    return coordinator.stateId ? { value: coordinator.stateId, label: coordinator.stateName } : null
                  }}
                />
              </div>

              <div className="col-md-6">
                <CustomTextField
                  labelTitle="District"
                  id="district"
                  name="district"
                  placeholder="District"
                  showError={errors?.district}
                  errorMessage={errors?.district?.message}
                  register={register}
                  additionalClasses="profile_edit"
                  showMandatory={true}
                  setValue={setValues}

                  resetValue={resetDistrict}
                  setResetValue={setResetDistrict}
                />
              </div>



              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Taluka"
                  id="taluka"
                  name="taluka"
                  additionalClasses="profile_edit"
                  placeholder="Select Taluka"
                  showMandatory={true}
                  showError={errors?.taluka}
                  errorMessage={errors?.taluka?.message}
                  register={register}
                  setValue={setValues}
                  resetValue={resetTaluka}

                  setResetValue={setResetTaluka}
                />
              </div>



              <div className="col-md-6">
                <CustomTextField
                  labelTitle="Pin Code"
                  id="pinCode"
                  name="pinCode"
                  inputType={InputType.number}
                  placeholder="Select Pin Code"
                  showError={errors?.pinCode}
                  errorMessage={errors?.pinCode?.message}
                  register={register}
                  setValue={setValues}

                  showMandatory={true}
                  additionalClasses="profile_edit"
                  resetValue={resetPinCode}
                  setResetValue={setResetPinCode}
                />
              </div>


              {coordinator.referralCode ?
                <div className="col-md-6" >
                  <CustomTextField
                    labelTitle="Coordinators Code"
                    placeholder="Coordinators Code "
                    name="referralCode"
                    id="referralCode"
                    additionalClasses="profile_edit"
                    inputType={InputType.text}
                    register={register}
                    disabled={true}
                  />
                </div> : null}

              <div className="col-md-6 align-self-center">
                <div className=' form-check gap-2 d-flex fw-600 py-3 mt-3'>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexCheckChecked"
                    checked={termsChecked}
                    onChange={() => setTermsChecked(!termsChecked)}
                  />
                  <label class="form-check-label " for="flexCheckChecked">
                    <div className=' fw-500  fs-14'>Notify via Email</div>
                  </label>
                </div>
              </div>

              <div className="d-flex justify-content-end mt-3">
                <ButtonWithIcon
                  text={coordinator?.coordinator_id ? "Update" : "Submit"}
                  icon={SvgImages.tick_mark}
                  onClick={coordinator?.coordinator_id ? handleSubmit(editCoordinator) : handleSubmit(onSubmit)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCoordinators;
